/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DraftConnectionResponse} from '../models/DraftConnectionResponse';
import type {DraftPostponeRequest} from '../models/DraftPostponeRequest';
import type {Error} from '../models/Error';
import type {UpdateDraftConnectionRequest} from '../models/UpdateDraftConnectionRequest';

export interface DeleteDraftConnection$Request {
    draftConnectionId: number;
}

export interface DeleteDraftConnection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteDraftConnectionRequest = createAction<PayloadData<void, DeleteDraftConnection$Request>>('SSO_V2__DELETE_DRAFT_CONNECTION__REQUEST');
export const deleteDraftConnectionSuccess = createAction<PayloadData<void, DeleteDraftConnection$Request>>('SSO_V2__DELETE_DRAFT_CONNECTION__SUCCESS');
export const deleteDraftConnectionFailure = createAction<PayloadData<Error, DeleteDraftConnection$Request, true>>('SSO_V2__DELETE_DRAFT_CONNECTION__FAILURE');

export const deleteDraftConnectionActions = [
    deleteDraftConnectionRequest,
    deleteDraftConnectionSuccess,
    deleteDraftConnectionFailure
] as const;

/**
 * @param {number} meta.draftConnectionId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteDraftConnection = (meta: DeleteDraftConnection$Request, config?: DeleteDraftConnection$Config) => {
    return {
        CALL_API: {
            types: deleteDraftConnectionActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/sso/draft/connections/${meta.draftConnectionId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDraftConnection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDraftConnectionRequest = createAction<PayloadData<void>>('SSO_V2__GET_DRAFT_CONNECTION__REQUEST');
export const getDraftConnectionSuccess = createAction<PayloadData<DraftConnectionResponse>>('SSO_V2__GET_DRAFT_CONNECTION__SUCCESS');
export const getDraftConnectionFailure = createAction<PayloadData<Error, void, true>>('SSO_V2__GET_DRAFT_CONNECTION__FAILURE');

export const getDraftConnectionActions = [
    getDraftConnectionRequest,
    getDraftConnectionSuccess,
    getDraftConnectionFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDraftConnection = (config?: GetDraftConnection$Config) => {
    return {
        CALL_API: {
            types: getDraftConnectionActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sso/draft/connections`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface PostponeSsoDraftFinalization$Request {
    draftPostponeRequest: DraftPostponeRequest;
}

export interface PostponeSsoDraftFinalization$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const postponeSsoDraftFinalizationRequest = createAction<PayloadData<void, PostponeSsoDraftFinalization$Request>>('SSO_V2__POSTPONE_SSO_DRAFT_FINALIZATION__REQUEST');
export const postponeSsoDraftFinalizationSuccess = createAction<PayloadData<void, PostponeSsoDraftFinalization$Request>>('SSO_V2__POSTPONE_SSO_DRAFT_FINALIZATION__SUCCESS');
export const postponeSsoDraftFinalizationFailure = createAction<PayloadData<Error, PostponeSsoDraftFinalization$Request, true>>('SSO_V2__POSTPONE_SSO_DRAFT_FINALIZATION__FAILURE');

export const postponeSsoDraftFinalizationActions = [
    postponeSsoDraftFinalizationRequest,
    postponeSsoDraftFinalizationSuccess,
    postponeSsoDraftFinalizationFailure
] as const;

/**
 * @param {DraftPostponeRequest} meta.draftPostponeRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const postponeSsoDraftFinalization = (meta: PostponeSsoDraftFinalization$Request, config?: PostponeSsoDraftFinalization$Config) => {
    return {
        CALL_API: {
            types: postponeSsoDraftFinalizationActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/sso/draft/postpone`,
            TRANSPORT_REQUEST_BODY: meta.draftPostponeRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateDraftConnection$Request {
    updateDraftConnectionRequest: UpdateDraftConnectionRequest;
}

export interface UpdateDraftConnection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateDraftConnectionRequest = createAction<PayloadData<void, UpdateDraftConnection$Request>>('SSO_V2__UPDATE_DRAFT_CONNECTION__REQUEST');
export const updateDraftConnectionSuccess = createAction<PayloadData<DraftConnectionResponse, UpdateDraftConnection$Request>>('SSO_V2__UPDATE_DRAFT_CONNECTION__SUCCESS');
export const updateDraftConnectionFailure = createAction<PayloadData<Error, UpdateDraftConnection$Request, true>>('SSO_V2__UPDATE_DRAFT_CONNECTION__FAILURE');

export const updateDraftConnectionActions = [
    updateDraftConnectionRequest,
    updateDraftConnectionSuccess,
    updateDraftConnectionFailure
] as const;

/**
 * @param {UpdateDraftConnectionRequest} meta.updateDraftConnectionRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateDraftConnection = (meta: UpdateDraftConnection$Request, config?: UpdateDraftConnection$Config) => {
    return {
        CALL_API: {
            types: updateDraftConnectionActions,
            method: ApiMethods.PATCH,
            endpoint: `/web-api/sso/draft/connections`,
            TRANSPORT_REQUEST_BODY: meta.updateDraftConnectionRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

